import { connect } from 'react-redux'
import SessionStatusPanel from './SessionStatusPanel'
import { State } from '../../dataStore/reducers/reducerType'
import { SessionStatusPanelProps } from './types'

const mapStateToProps = (state: State): SessionStatusPanelProps => ({
  debug: state.config.debug,
  eventLog: state.sessionStatus.eventLog,
  roomStatus: state.sessionStatus.roomStatus,
  syncClientStatus: state.sessionStatus.syncClientStatus
})

export default connect(mapStateToProps)(SessionStatusPanel)
